<template>
	<div
		class="cco-spinner"
		:class="['cco-spinner--' + version, { 'cco-spinner--loading': loading }]"
	>
		<div v-if="loading" class="cco-spinner__loading">
			<Loader class="o-loader--blue o-loader--small"></Loader>
		</div>
		<div v-else class="cco-spinner__actions" v-if="!isSingle">
			<button
				:aria-label="translations['Remove']"
				class="decrease"
				@click="decrease"
				:class="
					itemQty <= 1 && version == 'product' ? 'decrease--disabled' : ''
				"
			>
				<TrashIcon
					v-if="itemQty <= 1 && version != 'product'"
					class="delete-icon"
				></TrashIcon>
				<DecreaseIcon v-else class="minus-icon"> </DecreaseIcon>
			</button>
			<div class="amount">
				{{ itemQty }}
			</div>
			<button
				class="increase"
				@click="increase"
				:aria-label="translations['Add']"
			>
				<IncreaseIcon></IncreaseIcon>
			</button>
		</div>
		<div class="cco-spinner__actions" v-if="!loading">
			<button
				class="decrease"
				@click="decrease"
				v-if="isSingle"
				:aria-label="translations['Delete']"
			>
				<TrashIcon class="delete-icon"></TrashIcon>
			</button>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import request from '@/vue/mixins/request.js';
import { debounce } from '@/vue/utils/helpers';
import * as map from '@/vue/mixins/map';

//Components
import Loader from '../../objects/Loader.vue';

//Icons
import IncreaseIcon from '@web/assets/icon/add.svg';
import TrashIcon from '@web/assets/icon/trash.svg';
import DecreaseIcon from '@web/assets/icon/subtract.svg';

export default {
	name: 'Spinner',
	mixins: [request, map.cart],
	props: {
		version: {
			type: String,
			default: 'product',
		},
		qty: {
			type: Number,
			default: 1,
		},
		lineItem: {
			type: [Object, Boolean],
			default: false,
		},
		isSingle: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Loader,

		DecreaseIcon,
		IncreaseIcon,
		TrashIcon,
	},
	data: () => {
		return {
			itemQty: 1,
		};
	},
	watch: {
		cart: {
			deep: true,
			handler(value) {
				if (
					this.cart.lineItems[this.lineItem?.id]?.qty !== this.itemQty &&
					this.lineItem?.id
				) {
					this.itemQty = this.cart.lineItems[this.lineItem?.id]?.qty;
				}
			},
		},
	},
	methods: {
		decrease() {
			if (!this.lineItem && this.itemQty == 1) {
				return;
			}

			if (this.itemQty == 0) {
				return;
			} else {
				this.itemQty -= 1;
			}
			if (!this.lineItem) {
				this.emitChanged(this.itemQty, this);
			} else {
				this.inputChanged(this.itemQty, this);
			}
		},

		increase() {
			this.itemQty += 1;
			if (!this.lineItem) {
				this.emitChanged();
			} else {
				this.inputChanged(this.itemQty, this);
			}
		},

		emitChanged() {
			this.$emit('updated', parseInt(this.itemQty));
		},

		inputChanged: debounce((amount, vm) => {
			vm.updateCart(amount);
		}, 500),

		updateCart(amount) {
			if (!this.cart) {
				setTimeout(() => {
					this.updateCart(amount);
				}, 300);
				return;
			}

			// If lineitem exists in cart
			if (this.lineItem && this.cart.lineItems[this.lineItem?.id]) {
				const formData = new FormData();

				formData.append('action', this.action.updateCart);
				formData.append(
					'lineItems[' + this.cart.lineItems[this.lineItem?.id].id + '][qty]',
					amount
				);

				this.request(formData).then(() => {
					if (this.res.data?.cart) {
						this.$store.dispatch('commerce/cart', this.res.data.cart);
					}
				});
			}
		},
	},

	created() {
		this.itemQty = this.qty;
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.cco-spinner {
	@include size-fix(120px, 50px);
	border: 1px solid $c-blue;

	&__actions {
		height: 100%;
		width: 100%;

		display: flex;
		align-items: center;

		color: $c-blue;

		.decrease,
		.increase {
			display: flex;
			align-items: center;
			height: 100%;

			cursor: pointer;

			svg {
				width: 14px;
			}
		}

		.decrease {
			padding-left: 16px;
			padding-right: 10px;
			&--disabled {
				cursor: default;
				svg {
					path {
						stroke: $c-grey;
					}
				}
			}
		}

		.increase {
			padding-right: 16px;
			padding-left: 10px;
		}

		.amount {
			position: relative;
			top: -1px;
			min-width: 30px;
			display: flex;
			flex: 1;

			justify-content: center;
		}
	}

	&__loading {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&--cart {
		@include size-fix(110px, 35px);

		.decrease {
			padding-left: 12px;
		}

		.increase {
			padding-right: 12px;
		}
	}
}
</style>
